(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zazzo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zazzo-reviews-carousel')) {
    class ZazzoReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.zr__track');
        this.cards = [...this.querySelectorAll('.zr__card')];
        this.dots = [...this.querySelectorAll('.zr__dot')];
        this.prev = this.querySelector('.zr__arrow[data-dir="-1"]');
        this.next = this.querySelector('.zr__arrow[data-dir="1"]');
        if (!this.track || !this.cards.length) return;

        this.querySelectorAll('.zr__arrow').forEach((btn) =>
          btn.addEventListener('click', () => { this.stop(); this.step(Number(btn.dataset.dir)); })
        );
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => { this.stop(); this.goTo(Number(dot.dataset.index)); })
        );

        this.onScroll = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.track.addEventListener('pointerdown', () => this.stop(), { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); this.stop();
            this.step((e.key === 'ArrowRight' ? 1 : -1) * (this.isRtl() ? -1 : 1));
          }
        });
        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        // Theme editor: bring the selected review into view
        this.onBlockSelect = (e) => {
          const i = this.cards.findIndex((c) => c.contains(e.target));
          if (i > -1) { this.stop(); this.goTo(i); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      isRtl() { return getComputedStyle(this.track).direction === 'rtl'; }

      // Index of the first card that is (mostly) in view
      currentIndex() {
        const start = this.track.getBoundingClientRect();
        const rtl = this.isRtl();
        let best = 0, bestDist = Infinity;
        this.cards.forEach((c, i) => {
          const r = c.getBoundingClientRect();
          const d = Math.abs(rtl ? start.right - r.right : r.left - start.left);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      maxScroll() { return this.track.scrollWidth - this.track.clientWidth; }
      atEnd() { return Math.abs(this.track.scrollLeft) >= this.maxScroll() - 2; }
      atStart() { return Math.abs(this.track.scrollLeft) <= 2; }

      goTo(i) {
        const card = this.cards[Math.max(0, Math.min(i, this.cards.length - 1))];
        const t = this.track.getBoundingClientRect();
        const r = card.getBoundingClientRect();
        const delta = this.isRtl() ? r.right - t.right : r.left - t.left;
        this.track.scrollBy({ left: delta });
      }

      step(dir) {
        if (dir > 0 && this.atEnd()) return this.goTo(0);
        if (dir < 0 && this.atStart()) return this.goTo(this.cards.length - 1);
        this.goTo(this.currentIndex() + dir);
      }

      update() {
        const i = this.atEnd() ? this.cards.length - 1 : this.currentIndex();
        this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        const scrollable = this.maxScroll() > 2;
        if (this.prev) this.prev.disabled = !scrollable;
        if (this.next) this.next.disabled = !scrollable;
        this.querySelector('.zr__controls')?.toggleAttribute('hidden', !scrollable && this.dots.length < 2);
      }

      start() {
        if (this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && window.Shopify.designMode) return;
        const speed = Number(this.dataset.speed) || 5000;
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.step(1); }, speed);
      }

      stop() { clearInterval(this.timer); this.timer = null; }
    }
    customElements.define('zazzo-reviews-carousel', ZazzoReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
